module.exports = __webpack_public_path__ + "img/bg-widget-user.53c71ce8.svg";